import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(function Textarea({ className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-20 w-full rounded border border-border bg-surface-input px-3 py-2 text-sm text-fg',
        'placeholder:text-fg-tertiary',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:text-fg-disabled',
        'aria-invalid:border-crit aria-invalid:ring-crit',
        className,
      )}
      {...props}
    />
  );
});
